import React, { useState, useEffect } from 'react';
import { Message } from 'semantic-ui-react';
import { string } from 'prop-types';
import { FormattedMessage } from 'react-intl';
function Disclaimer({ page }) {
  const [disclaimerStatus, setDisclaimerStatus] = useState('');

  useEffect(() => {
    setDisclaimerStatus(getNotificationStatus(page));
  }, []);

  const getNotificationStatus = notificationType => {
    const cookieExists = document.cookie
      .split(' ')
      .find(word => word.includes(notificationType));

    if (cookieExists) {
      return cookieExists.split('=')[1].replace(';', '');
    }

    return null;
  };

  const onDismissClick = () => {
    document.cookie = `${page}=false; expires=Fri, 31 Dec 9999 23:59:59 GMT`;
    setDisclaimerStatus(getNotificationStatus(page));
  };

  return disclaimerStatus === 'false' ? null : (
    <Message
      info
      onDismiss={onDismissClick}
      content={
        <FormattedMessage
          id="disclaimer.copy"
          description="Disclaimer text for new products"
          defaultMessage="We are constantly updating this list and NEW products and brands will be added soon."
        />
      }
      icon="info circle"
      data-testid="disclaimer-component"
    />
  );
}

Disclaimer.propTypes = {
  page: string
};

export default Disclaimer;



// WEBPACK FOOTER //
// ./src/components/Disclaimer/Disclaimer.js